import styles from "./MultiLineText.module.css";

interface Props {
    primary: string;
    secondary: string;
}

export default function MultiLineText({ primary, secondary }: Props) {
    return (
        <div data-cy="multi-line">
            <p className={styles.primary}>{primary}</p>
            <p className={styles.secondary}>{secondary}</p>
        </div>
    );
}
